import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-delete-story-dialog',
  standalone: true,
  imports: [],
  templateUrl: './delete-story-dialog.component.html',
  styleUrl: './delete-story-dialog.component.scss'
})
export class DeleteStoryDialogComponent {
  // create reference to dialog and pass the data type to pass to parent component when dialog is closed (boolean) to trigger save or cancel
  dialogRef = inject<DialogRef<boolean>>(DialogRef<boolean>);
  data = inject(DIALOG_DATA);
}
